export default __webpack_public_path__ + "static/media/DENTISTCERTIFICATEA5.80a23c57.png";